'use strict';

import sal from 'sal.js';

import {hasDataPageAttribute, waitForDependencies} from "../_imports/utils/utils.common";

import {
    debouncer
} from '../../utils/utils';

const dispatchStyle = ($banner, bannerClasses) => {
    if (bannerClasses.includes('fw-blue-turquoise')) {
        if (breakpoint === 'xs' || breakpoint === 'sm') {
            $banner.find('.button.secondary').addClass('invert');
        } else {
            $banner.find('.button.secondary.invert').removeClass('invert');
        }
    }
};

const initCtaBanners = () => {
    $('.cta-banner').each(function() {
        const $ctaBanner = $(this);
        const $ctaBannerContent = $ctaBanner.find('.cta-banner-content');
        const bannerClasses = $ctaBannerContent.prop('class');

        if (bannerClasses) {
            dispatchStyle($ctaBanner, bannerClasses);
        }
    });

    if(hasDataPageAttribute('wsj-gen-ai')) {
        sal({
            selector: '.cta-banner.primary-to-accent-gradient [data-animated-arrow]',
        });
    }
};

waitForDependencies(() => {
    initCtaBanners();

    $(window).on('resize', function(){
        debouncer(initCtaBanners(), 150);
    });
});
